import React from "react";
import { buildColor } from "@tvg/design-system";
import styled, { keyframes } from "styled-components";
import RunnerMobileLoading from "./RunnerMobileLoading";
import { RunnerModifierEnum } from "../../types";

interface LoadingProps {
  isMobile?: boolean;
  isLiveTv?: boolean;
  runnerModifier: RunnerModifierEnum;
}

const pulseAnimation = keyframes`
  0% {
    opacity: 1
  }

  50% {
    opacity: 0.5
  }

  100% {
    opacity: 1
  }
`;

const SVG = styled.svg`
  animation: ${pulseAnimation} 1.25s infinite;
`;

const MobileContainer = styled.div`
  border-top: 1px solid ${buildColor("blue", "100")};
  background-color: ${buildColor("white", "900")};
  margin-top: 12px;
`;

const RaceCardLoading = ({ isLiveTv }: Pick<LoadingProps, "isLiveTv">) => (
  <SVG
    width="100%"
    height="auto"
    viewBox={`0 0 1074 ${isLiveTv ? 678 : 602}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {isLiveTv ? (
      <g filter="url(#a)">
        <path fill="#fff" d="M0 1h736v145H0z" />
        <rect x="12" y="18" width="200" height="20" rx="1" fill="#E9EFF5" />
        <rect x="12" y="51" width="20" height="16" rx="1" fill="#E9EFF5" />
        <rect x="44" y="51" width="471" height="16" rx="1" fill="#E9EFF5" />
        <rect x="12" y="78" width="644" height="12" rx="1" fill="#E9EFF5" />
        <rect x="12" y="101" width="644" height="32" rx="1" fill="#E9EFF5" />
      </g>
    ) : (
      <g filter="url(#a)">
        <path fill="#fff" d="M0 1h736v69H0z" />
        <rect x="12" y="17" width="67" height="16" rx="1" fill="#E9EFF5" />
        <rect x="12" y="43" width="550" height="12" rx="1" fill="#E9EFF5" />
      </g>
    )}
    <g filter="url(#b)" transform={`translate(0,${isLiveTv ? 77 : 0})`}>
      <path fill="#FAFCFF" d="M0 70h736v56H0z" />
      <rect x="12" y="82" width="239" height="32" rx="2" fill="#E9EFF5" />
      <rect x="263" y="92" width="150" height="12" rx="2" fill="#E9EFF5" />
    </g>
    <g clipPath="url(#c)" transform={`translate(0,${isLiveTv ? 77 : 0})`}>
      <path fill="#fff" d="M0 126h736v476H0z" />
      <g filter="url(#d)">
        <path fill="#fff" d="M0 126h736v68H0z" />
        <rect x="12" y="138" width="55" height="44" rx="2" fill="#E9EFF5" />
        <rect x="79" y="144" width="150" height="12" rx="1" fill="#E9EFF5" />
        <rect x="79" y="165" width="250" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="144" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="165" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="644" y="138" width="80" height="44" rx="2" fill="#E9EFF5" />
      </g>
      <g filter="url(#e)">
        <path fill="#fff" d="M0 194h736v68H0z" />
        <rect x="12" y="206" width="55" height="44" rx="2" fill="#E9EFF5" />
        <rect x="79" y="212" width="150" height="12" rx="1" fill="#E9EFF5" />
        <rect x="79" y="233" width="250" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="212" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="233" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="644" y="206" width="80" height="44" rx="2" fill="#E9EFF5" />
      </g>
      <g filter="url(#f)">
        <path fill="#fff" d="M0 262h736v68H0z" />
        <rect x="12" y="274" width="55" height="44" rx="2" fill="#E9EFF5" />
        <rect x="79" y="280" width="150" height="12" rx="1" fill="#E9EFF5" />
        <rect x="79" y="301" width="250" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="280" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="301" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="644" y="274" width="80" height="44" rx="2" fill="#E9EFF5" />
      </g>
      <g filter="url(#g)">
        <path fill="#fff" d="M0 330h736v68H0z" />
        <rect x="12" y="342" width="55" height="44" rx="2" fill="#E9EFF5" />
        <rect x="79" y="348" width="150" height="12" rx="1" fill="#E9EFF5" />
        <rect x="79" y="369" width="250" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="348" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="369" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="644" y="342" width="80" height="44" rx="2" fill="#E9EFF5" />
      </g>
      <g filter="url(#h)">
        <path fill="#fff" d="M0 398h736v68H0z" />
        <rect x="12" y="410" width="55" height="44" rx="2" fill="#E9EFF5" />
        <rect x="79" y="416" width="150" height="12" rx="1" fill="#E9EFF5" />
        <rect x="79" y="437" width="250" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="416" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="437" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="644" y="410" width="80" height="44" rx="2" fill="#E9EFF5" />
      </g>
      <g filter="url(#i)">
        <path fill="#fff" d="M0 466h736v68H0z" />
        <rect x="12" y="478" width="55" height="44" rx="2" fill="#E9EFF5" />
        <rect x="79" y="484" width="150" height="12" rx="1" fill="#E9EFF5" />
        <rect x="79" y="505" width="250" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="484" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="505" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="644" y="478" width="80" height="44" rx="2" fill="#E9EFF5" />
      </g>
      <g filter="url(#j)">
        <path fill="#fff" d="M0 534h736v68H0z" />
        <rect x="12" y="546" width="55" height="44" rx="2" fill="#E9EFF5" />
        <rect x="79" y="552" width="150" height="12" rx="1" fill="#E9EFF5" />
        <rect x="79" y="573" width="250" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="552" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="580" y="573" width="52" height="12" rx="1" fill="#E9EFF5" />
        <rect x="644" y="546" width="80" height="44" rx="2" fill="#E9EFF5" />
      </g>
    </g>
    <rect x="747.5" y=".5" width="326" height="168" rx="4.5" fill="#fff" />
    <rect x="747.5" y=".5" width="326" height="168" rx="4.5" stroke="#D6E3F0" />
    <path
      d="M1069 179.5H752a4.5 4.5 0 0 0-4.5 4.5v159a4.5 4.5 0 0 0 4.5 4.5h317c2.49 0 4.5-2.015 4.5-4.5V184c0-2.485-2.01-4.5-4.5-4.5"
      fill="#fff"
    />
    <path
      d="M1069 179.5H752a4.5 4.5 0 0 0-4.5 4.5v159a4.5 4.5 0 0 0 4.5 4.5h317c2.49 0 4.5-2.015 4.5-4.5V184c0-2.485-2.01-4.5-4.5-4.5Z"
      stroke="#D6E3F0"
    />
    <path
      d="M1069 358.5H752a4.5 4.5 0 0 0-4.5 4.5v159a4.5 4.5 0 0 0 4.5 4.5h317c2.49 0 4.5-2.015 4.5-4.5V363c0-2.485-2.01-4.5-4.5-4.5"
      fill="#fff"
    />
    <path
      d="M1069 358.5H752a4.5 4.5 0 0 0-4.5 4.5v159a4.5 4.5 0 0 0 4.5 4.5h317c2.49 0 4.5-2.015 4.5-4.5V363c0-2.485-2.01-4.5-4.5-4.5Z"
      stroke="#D6E3F0"
    />
    <defs>
      <filter
        id="a"
        x="0"
        y="1"
        width="736"
        height={isLiveTv ? 145 : 69}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_6607_446342" />
      </filter>
      <filter
        id="b"
        x="0"
        y="70"
        width="736"
        height="56"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_6607_446342" />
      </filter>
      <filter
        id="d"
        x="0"
        y="126"
        width="736"
        height="68"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_6607_446342" />
      </filter>
      <filter
        id="e"
        x="0"
        y="194"
        width="736"
        height="68"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_6607_446342" />
      </filter>
      <filter
        id="f"
        x="0"
        y="262"
        width="736"
        height="68"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_6607_446342" />
      </filter>
      <filter
        id="g"
        x="0"
        y="330"
        width="736"
        height="68"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_6607_446342" />
      </filter>
      <filter
        id="h"
        x="0"
        y="398"
        width="736"
        height="68"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_6607_446342" />
      </filter>
      <filter
        id="i"
        x="0"
        y="466"
        width="736"
        height="68"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_6607_446342" />
      </filter>
      <filter
        id="j"
        x="0"
        y="534"
        width="736"
        height="68"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_6607_446342" />
      </filter>
      <clipPath id="c">
        <path fill="#fff" d="M0 126h736v476H0z" />
      </clipPath>
    </defs>
  </SVG>
);

const MobileHeader = () => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="101"
    viewBox="0 0 375 101"
    fill="none"
    preserveAspectRatio="none"
  >
    <g filter="url(#filter0_ii_3330_302896)">
      <rect width="100%" height="101" fill="white" />
      <rect x="12" y="18" width="67" height="16" rx="1" fill="#E9EFF5" />
      <rect x="12" y="50" width="351" height="12" rx="1" fill="#E9EFF5" />
      <rect x="12" y="68" width="351" height="12" rx="1" fill="#E9EFF5" />
    </g>
    <defs>
      <filter
        id="filter0_ii_3330_302896"
        x="0"
        y="0"
        width="100%"
        height="101"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_3330_302896"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_3330_302896"
          result="effect2_innerShadow_3330_302896"
        />
      </filter>
    </defs>
  </SVG>
);

const LiveTVMobileHeader = () => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="136"
    viewBox="0 0 375 136"
    fill="none"
    preserveAspectRatio="none"
  >
    <mask id="path-1-inside-1_13837_174985" fill="white">
      <path d="M0 0H375V136H0V0Z" />
    </mask>
    <path d="M0 0H375V136H0V0Z" fill="white" />
    <path
      d="M0 1H375V-1H0V1ZM375 135H0V137H375V135Z"
      fill="#D6E3F0"
      mask="url(#path-1-inside-1_13837_174985)"
    />
    <rect x="12" y="18" width="351" height="16" rx="1" fill="#E9EFF5" />
    <rect x="12" y="50" width="351" height="12" rx="1" fill="#E9EFF5" />
    <rect x="12" y="68" width="351" height="12" rx="1" fill="#E9EFF5" />
    <rect x="12" y="96" width="351" height="23" rx="1" fill="#E9EFF5" />
  </SVG>
);

const MobileOptions = () => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="40"
    viewBox="0 0 375 40"
    fill="none"
    preserveAspectRatio="none"
  >
    <g filter="url(#filter0_i_3330_304308)">
      <rect width="100%" height="40" fill="#FAFCFF" />
      <rect x="12" y="14" width="117" height="12" rx="2" fill="#E9EFF5" />
      <path
        d="M143.215 26.8457H142.196V15.0469H143.215V26.8457Z"
        fill="#DEE1E3"
      />
      <rect x="157" y="14" width="51" height="12" rx="2" fill="#E9EFF5" />
    </g>
    <defs>
      <filter
        id="filter0_i_3330_304308"
        x="0"
        y="0"
        width="100%"
        height="40"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_3330_304308"
        />
      </filter>
    </defs>
  </SVG>
);

const MobileRaceCardLoading = ({
  isLiveTv,
  runnerModifier
}: Pick<LoadingProps, "isLiveTv" | "runnerModifier">) => (
  <MobileContainer>
    {isLiveTv ? <LiveTVMobileHeader /> : <MobileHeader />}
    <MobileOptions />
    <RunnerMobileLoading variant={runnerModifier} numberOfCards={5} />
  </MobileContainer>
);

const Loading = ({
  isMobile = false,
  isLiveTv = false,
  runnerModifier = RunnerModifierEnum.DEFAULT
}: LoadingProps) =>
  isMobile ? (
    <MobileRaceCardLoading
      isLiveTv={isLiveTv}
      runnerModifier={runnerModifier}
    />
  ) : (
    <RaceCardLoading isLiveTv={isLiveTv} />
  );

export default Loading;
